import { render, staticRenderFns } from "./ViewPayments.vue?vue&type=template&id=66024df0"
import script from "./ViewPayments.vue?vue&type=script&lang=js"
export * from "./ViewPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports